import useFetch from "./useFetch";
import { useStateValue } from "../context-store/AppStateProvider";

const useAccount = () => {
    const [{ userId, launchCourseId }] = useStateValue();

    const endpointPath = `availableLearnerSeats`;
    return useFetch(endpointPath, { userId, courseId: launchCourseId });
};

export default useAccount;
